import React from 'react';
import { Button, FormInput, FormSelect, FormTextEditor } from '@getro/rombo';
import { Field, Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { X } from 'lucide-react';

import { useNoteForm } from './useNoteForm';
import { FormObserver } from '../../../../atoms/formObserver';

export const NoteForm = ({ note = {}, isLoading, onSuccess, onClose, draft, onDraftChange }) => {
  const { formKeyIndex, formSchema, initialValues, externalOptions, isCreateNote, onSubmit, handleValuesChange } =
    useNoteForm({
      note,
      onSuccess,
      draft,
      onDraftChange,
    });

  return (
    <Formik
      key={`note-form-${formKeyIndex}`}
      initialValues={initialValues}
      validationSchema={formSchema}
      onSubmit={onSubmit}
    >
      <Form style={{ width: '100%' }}>
        {isCreateNote && <FormObserver onChange={handleValuesChange} />}
        <Flex flexDirection="column" sx={{ gap: '8px' }}>
          <Flex alignItems="center" justifyContent="space-between">
            <Text fontSize="14px" fontWeight="medium" color="text.dark">
              {isCreateNote ? 'Add new note' : 'Edit note'}
            </Text>
            {!isCreateNote && (
              <Box sx={{ color: 'neutral.400' }}>
                <Box as={X} size="16px" aria-hidden="true" onClick={onClose} sx={{ cursor: 'pointer' }} />
              </Box>
            )}
          </Flex>
          <Field name="title" placeholder="Note title (optional)" component={FormInput} />
          <Field name="body" placeholder="Add a note about this contact" component={FormTextEditor} />
          <Flex alignItems="center" justifyContent="flex-end" sx={{ gap: '8px' }}>
            <Flex sx={{ minWidth: '320px' }}>
              <Field
                tabIndex="0"
                name="external"
                component={FormSelect}
                options={externalOptions}
                containerProps={{ flex: 1 }}
              />
            </Flex>
            <Button type="submit" loading={isLoading}>
              {isCreateNote ? 'Add note' : 'Update note'}
            </Button>
          </Flex>
        </Flex>
      </Form>
    </Formik>
  );
};

NoteForm.propTypes = {
  note: PropTypes.object,
  isLoading: PropTypes.bool,
  onSuccess: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  draft: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.string,
  }),
  onDraftChange: PropTypes.func,
};

NoteForm.defaultProps = {
  note: {},
  isLoading: false,
  onClose: () => {},
  draft: null,
  onDraftChange: null,
};
